import * as types from './mutation-types.js'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    pourThemeData: [], //倾诉主题
    keyWordData: { //关键词
      data: [{
          name: '关键词1',
          value: 130,
        },
        {
          name: '关键词2',
          value: 127,
        },
        {
          name: '关键词3',
          value: 105,
        },
        {
          name: '关键词4',
          value: 105,
        },
        {
          name: '关键词5',
          value: 100,
        },
        {
          name: '关键词6',
          value: 94,
        },
        {
          name: '关键词7',
          value: 92,
        },
        {
          name: '关键词8',
          value: 91,
        },
        // {
        //   name: '流动',
        //   value: 88,
        // },
        // {
        //   name: '整改',
        //   value: 84,
        // },
      ],
      showValue: true,
    },
    programmeData: [ // 年度方案任务
      {
        complete: 1051,
        total: 400
      },
      {
        complete: 1552,
        total: 1200
      },
      {
        complete: 101,
        total: 24
      },
      {
        complete: 33,
        total: 36
      },
      {
        complete: 68,
        total: 24
      },
      {
        complete: 353,
        total: 600
      },
    ],
    caseData: { //优秀案例
      header: [
        '<span style="color:#37f3f3">案例名称</span>',
      ],
      // headerHeight: 24,
      headerBGC: 'transparent',
      data: [
        ['感觉世界与我为敌!一个妄想症患者的"闹访"'],
        ['情侣纠纷闹范媛，心理疏导为玉帛'],
        ['身心的救赎，摆正人生轨迹'],
        ['破碎家庭的屋檐下有个哭泣的青少年'],
        ['感觉世界与我为敌!一个妄想症患者的"闹访"'],
        ['情侣纠纷闹范媛，心理疏导为玉帛'],
        ['身心的救赎，摆正人生轨迹'],
        ['破碎家庭的屋檐下有个哭泣的青少年'],
      ],
      rowNum: 5,
    },
    doctorClassData: [], //咨询师类别
    doctorLvData: [], //咨询师级别
    doctorTaskType: [], //任务类别
    anchorList: [{ //锚点列表
      name: '基本资料',
      href: 'anchor1'
    }, {
      name: '来访者主诉',
      href: 'anchor2'
    }, {
      name: '咨询师观察',
      href: 'anchor3'
    }, {
      name: '目前存在的问题',
      href: 'anchor4'
    }, {
      name: '拟定的咨询目标及干预策略',
      href: 'anchor5'
    }, {
      name: '干预与处理',
      href: 'anchor6'
    }, {
      name: '咨询师总结',
      href: 'anchor7'
    }]
  },
  getters: {
    pourThemeData: state => state.pourThemeData,
    keyWordData: state => state.keyWordData,
    caseData: state => state.caseData,
    programmeData: state => state.programmeData,
    doctorClassData: state => state.doctorClassData,
    doctorLvData: state => state.doctorLvData,
    doctorTaskType: state => state.doctorTaskType,
    anchorList: state => state.anchorList
  },
  mutations: {
    [types.GET_KEY_WORD_LIST](state, payload) {
      state.keyWordData = payload
    },
    [types.GET_POUR_THEME_LIST](state, payload) {
      state.pourThemeData = payload
    },
    [types.GET_DOCTOR_CLASS_LIST](state, payload) {
      state.doctorClassData = payload
    },
    [types.GET_DOCTOR_LV_LIST](state, payload = 0) {
      state.doctorLvData = state.doctorClassData[payload].lvL
      // state.doctorLvData = payload
    },
    [types.GET_DOCTOR_TASK_TYPE](state, payload) {
      state.doctorTaskType = payload
    },
  },
  actions: {
    getKeyWordList({ //获取关键词
      commit
    }) {
      return axios.get('api/XLFWyzy/GetKeyTop').then(res => {
        console.log(res)
        commit(types.GET_KEY_WORD_LIST, res.data.ResultData)
      })
    },
    getPourThemeList({
      commit
    }) {
      return axios.get('api/XLFWyzy/GetSubject', {
        params: {
          pageindex: 1,
          pagesize: 20
        }
      }).then(res => {
        console.log(res)
        commit(types.GET_POUR_THEME_LIST, res.data.ResultData)
      })
    },
    getDoctorClassList({ //类别
      commit
    }) {
      return axios.get('api/XLFWyzy/GetDoctorStatistics').then(res => {
        commit(types.GET_DOCTOR_CLASS_LIST, res.data.ResultData[0])
        commit(types.GET_DOCTOR_LV_LIST)
      })
    },
    getDoctorLvList({
      commit
    }) {
      return axios.get('api/XLFWyzy/GetDoctorLv').then(res => {
        commit(types.GET_DOCTOR_LV_LIST, res.data.ResultData)
      })
    },
    getDoctorTaskType({
      commit
    }, payload = {}) {
      let {
        address = '',
          minTime = '',
          maxTime = '',
      } = payload
      return axios.get('api/PlatformWTB/Search_Task_Type_Count', {
        params: {
          address,
          minTime,
          maxTime,
        }
      }).then(res => {
        console.log(res)
        commit(types.GET_DOCTOR_TASK_TYPE, res.data)
      })
    }
  },
}